import { GlobalType } from './GlobalType'

export const globalReducer = (state: GlobalState = initialGlobalState, action: GlobalActionInterface) => {
  switch (action.type) {
    case GlobalType.SHOW_LOADING_GLOBAL_COMPONENT:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.key]: true
        }
      }
    case GlobalType.HIDE_LOADING_GLOBAL_COMPONENT:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.key]: false
        }
      }

    case GlobalType.CLEAR_LOADED_DATA:
      return { ...initialGlobalState }

    default:
      return state
  }
}

/**
 *
 *@category Redux State
 * @export
 * @class GlobalState
 */
export interface GlobalState {
  /**
   *
   *
   * @type {{
   *     [loadingKey: string]: boolean
   *   }}
   * @memberof GlobalState
   */
  loading: {
    [loadingKey: string]: boolean
  }
}

export const initialGlobalState: GlobalState = {
  loading: {}
}

interface SHOW_LOADING_GLOBAL_COMPONENT {
  type: GlobalType.SHOW_LOADING_GLOBAL_COMPONENT
  payload: { key: string }
}
interface HIDE_LOADING_GLOBAL_COMPONENT {
  type: GlobalType.HIDE_LOADING_GLOBAL_COMPONENT
  payload: { key: string }
}

interface CLEAR_LOADED_DATA {
  type: GlobalType.CLEAR_LOADED_DATA
}

type GlobalActionInterface = SHOW_LOADING_GLOBAL_COMPONENT | HIDE_LOADING_GLOBAL_COMPONENT | CLEAR_LOADED_DATA
